module.exports = __webpack_public_path__ + "static/media/inexus_logo_white.e98bc7ca.svg";